// test1336
(1336 && 0);
